import * as Types from "../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BookingPracticeAppointmentReasonFieldsFragment = {
  __typename?: "PracticeAppointmentReason";
  id: string;
  slug?: string | null;
  appointmentReason?: {__typename?: "AppointmentReason"; id: string; name?: string | null} | null;
  specialties?: Array<{__typename?: "PracticeAppointmentReasonSpecialty"; id: string}> | null;
};

export type FetchAppointmentReasonsQueryVariables = Types.Exact<{
  slugs: Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"];
}>;

export type FetchAppointmentReasonsQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    appointmentReasons?: {
      __typename?: "PracticeAppointmentReasonConnection";
      nodes?: Array<{
        __typename?: "PracticeAppointmentReason";
        id: string;
        slug?: string | null;
        appointmentReason?: {
          __typename?: "AppointmentReason";
          id: string;
          name?: string | null;
        } | null;
        specialties?: Array<{__typename?: "PracticeAppointmentReasonSpecialty"; id: string}> | null;
      }> | null;
    } | null;
  } | null;
};

export const BookingPracticeAppointmentReasonFieldsFragmentDoc = gql`
  fragment BookingPracticeAppointmentReasonFields on PracticeAppointmentReason {
    id
    slug
    appointmentReason {
      id
      name
    }
    specialties {
      id
    }
  }
`;
export const FetchAppointmentReasonsDocument = gql`
  query FetchAppointmentReasons($slugs: [String!]!) {
    practice(id: "5bdaef44-8ff0-439f-99d7-3285afcc6911") {
      id
      appointmentReasons(slugs: $slugs) {
        nodes {
          ...BookingPracticeAppointmentReasonFields
        }
      }
    }
  }
  ${BookingPracticeAppointmentReasonFieldsFragmentDoc}
`;

/**
 * __useFetchAppointmentReasonsQuery__
 *
 * To run a query within a React component, call `useFetchAppointmentReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAppointmentReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAppointmentReasonsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useFetchAppointmentReasonsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAppointmentReasonsQuery,
    FetchAppointmentReasonsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<FetchAppointmentReasonsQuery, FetchAppointmentReasonsQueryVariables>(
    FetchAppointmentReasonsDocument,
    options,
  );
}
export function useFetchAppointmentReasonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAppointmentReasonsQuery,
    FetchAppointmentReasonsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<FetchAppointmentReasonsQuery, FetchAppointmentReasonsQueryVariables>(
    FetchAppointmentReasonsDocument,
    options,
  );
}
export type FetchAppointmentReasonsQueryHookResult = ReturnType<
  typeof useFetchAppointmentReasonsQuery
>;
export type FetchAppointmentReasonsLazyQueryHookResult = ReturnType<
  typeof useFetchAppointmentReasonsLazyQuery
>;
export type FetchAppointmentReasonsQueryResult = Apollo.QueryResult<
  FetchAppointmentReasonsQuery,
  FetchAppointmentReasonsQueryVariables
>;
